import { flatMap, omit } from "lodash"

export function flattenTree(nodes) {
  return flatMap(nodes, (node) => [omit(node, "children"), ...flattenTree(node.children || [])])
}
